var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.attentionShow,
          expression: "attentionShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "backupAttention" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("\n             Attention\n            "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                _vm.attentionShow = false
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "backupAttion-body" }, [
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "300Px", height: "100Px" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    fontSize: "14Px",
                    color: "#6f7886",
                    float: "left"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.cloudBackup.deleteVersion")))]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { marginTop: "10Px", float: "left" } }, [
                _c("div", {
                  staticClass: "icon-util",
                  class: _vm.check ? "check" : "nocheck",
                  staticStyle: { float: "left", marginRight: "10Px" },
                  on: {
                    click: function($event) {
                      return _vm.checkItem()
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      float: "left",
                      position: "relative",
                      top: "1Px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.cloudBackup.deleteFiles")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "icon-util question-max-mark",
                    attrs: { id: "maxMark" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "version-explanation" },
                      [
                        _c("font", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("language.cloudBackup.longerDelete")
                            )
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    float: "left",
                    width: "100%",
                    height: "40Px",
                    marginTop: "10Px"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticStyle: { width: "110Px", marginRight: "20Px" },
                      on: {
                        click: function($event) {
                          return _vm.deleteItem()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.delete")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "cancel-button",
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
                  )
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-497a29ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-497a29ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/delete_version_attention_popup.vue
// module id = null
// module chunks = 